import { useContext, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import loginBg from "../../assets/illustrations/login-bg.jfif";
import { T } from "../../constants/theme";
import { AuthContext } from "../../contexts/AuthContext";
import { ToastContext } from "../../contexts/ToastContext";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isAdminMode = searchParams.get("admin") === "1";
  const { forgotPassword } = useContext(AuthContext);
  const toast = useContext(ToastContext);

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    setError("");
    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      setError("Enter a valid email address");
      return;
    }
    setLoading(true);
    try {
      await forgotPassword(email.trim());
      setSent(true);
    } catch (e) {
      toast(e.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 20px",
        backgroundImage: `url(${loginBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(rgba(0,0,0,.45), rgba(0,0,0,.45))",
        }}
      />

      <button
        onClick={() => navigate(isAdminMode ? "/admin-login" : "/login")}
        style={{
          position: "absolute",
          top: 25,
          left: 25,
          zIndex: 10,
          border: "none",
          padding: "12px 18px",
          borderRadius: 12,
          background: "rgba(255,255,255,.15)",
          backdropFilter: "blur(10px)",
          color: T.ink,
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        ← Back to Sign In
      </button>

      <div
        style={{
          position: "relative",
          zIndex: 5,
          width: "100%",
          maxWidth: 480,
          padding: 40,
          borderRadius: 24,
          background: T.surface,
          backdropFilter: "blur(20px)",
          boxShadow: "0 12px 32px rgba(0,0,0,0.05)",
          border: `1px solid ${T.border}`,
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div
            style={{
              fontSize: 12,
              letterSpacing: 4,
              fontWeight: 700,
              color: T.muted,
              marginBottom: 10,
            }}
          >
            {isAdminMode ? "Admin Account Recovery" : "Account Recovery"}
          </div>
          <h1 style={{ margin: 0, fontSize: 30, color: T.ink }}>Forgot Password?</h1>
          <p style={{ marginTop: 12, color: T.muted, fontSize: 15, lineHeight: 1.6 }}>
            Enter the email on your account and we'll send you a link to reset your password.
          </p>
        </div>

        {sent ? (
          <div
            style={{
              background: T.goldLight,
              border: `1px solid ${T.gold}`,
              color: T.gold,
              padding: 16,
              borderRadius: 12,
              fontSize: 14,
              textAlign: "center",
            }}
          >
            If that email is registered, a password reset link has been sent to it.
          </div>
        ) : (
          <>
            <input
              style={{
                width: "100%",
                padding: 14,
                borderRadius: 12,
                border: error ? "1px solid #ff4d4f" : `1px solid ${T.border}`,
                background: T.paper,
                color: T.ink,
                fontSize: 14,
                outline: "none",
                marginBottom: 8,
              }}
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && submit()}
            />
            {error && (
              <div style={{ color: "#e53935", marginBottom: 10, fontSize: 13 }}>{error}</div>
            )}

            <button
              onClick={submit}
              disabled={loading}
              style={{
                width: "100%",
                marginTop: 8,
                padding: 14,
                borderRadius: 12,
                border: "none",
                background: T.gold,
                color: T.paper,
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
